import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { InstrumentDetailInfoComponent, InstrumentDetialHistoryComponent, StyledInstrumentDetailView } from ".";
import { CircularLoader, AppModal, AppAlert } from "..";
import { appRouteEnums } from "@enums";
import { instrumentApi } from "@api";
import { useAppSelector, setSelectedDateInstrument, setInstrumentsCategory, setIdConstuctionEmployeeSearch, selectInstrument } from "@redux";
import hot_yellow_frame from "@assets/Icons/hot_yellow_frame.svg";
import { Grid } from "@mui/material";
import moment from "moment";
import { calculateReservationsInMonth } from "src/Utils/CalculateRecurringBorrowings";
import { useAppNavigation, useShowErrorFromApi } from "@utils";
const queryString = require("query-string");

export const InstrumentDetailView = () => {
  const { id } = useParams<{ id: any }>();
  const parsed = queryString.parse(location.search);
  // redux state
  const instrument = useAppSelector(selectInstrument);
  // hooks
  const history = useHistory();
  const dispatch = useDispatch();
  const showErrorFromApi = useShowErrorFromApi();
  // component state
  const [productDetail, setProductDetail] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const resId = query.get("resId");
  const queryStart = query.get("start") || query.get("startDate");
  const categoryId = query.get("categoryId");
  const subCategoryId = query.get("subCategoryId");

  // what: fetch api get detail function
  const fetchProductApi = async () => {
    setLoading(true);
    try {
      const response = await instrumentApi.getInstrumentDetail({
        id,
      });
      setLoading(false);
      setProductDetail(response.data.data);
    } catch (err: any) {
      setLoading(false);
      if (err?.response?.status === 404 || err?.response?.status === 500) {
        console.log("Redirecting to instruments list due to product fetch error:", err);
        history.push(appRouteEnums.PATH_INSTRUMENTS);
      }
    }
  };

  const fetchHistoryProduct = async () => {
    setLoading(true);
    try {
      const response = await instrumentApi.getInstrumentBorrowingHistory({
        id,
        itemId: parsed.itemId,
      });
      setLoading(false);
      setProductDetail(response.data.data);
    } catch (err: any) {
      setLoading(false);
      if (err?.response?.status === 404 || err?.response?.status === 500) {
        console.log("Redirecting to instruments list due to history fetch error:", err);
        history.push(appRouteEnums.PATH_INSTRUMENTS);
      }
    }
  };
  const [showModal, setShowModal] = useState(false);
  const { navigatePreservingQuery } = useAppNavigation();

  const handleCloseModal = () => {
    setShowModal(false);
    dispatch(
      setInstrumentsCategory({
        category: "",
        subCategory: "",
      })
    );
    // 予約完了後、既存のクエリを維持しつつ categoryId / subCategoryId を上書きして一覧に戻る
    navigatePreservingQuery(appRouteEnums.PATH_INSTRUMENTS, { categoryId, subCategoryId }, "push");
  };

  const createNewBorrow = async (values: any) => {
    setLoading(true);

    console.log("createNewBorrow values:", values);

    if (!resId) {
      try {
        const effectRange = values.effectRange || ""; // "all" | "future" | "this"
        const reservationId = values.reservationId || null; // this is called "borrowings_id" in the backend

        const apiPayload = {
          from: values.startDate,
          to: values.endDate,
          fromTime: values.fromTime,
          toTime: values.toTime,
          oldStart: values.oldStart,
          newStart: `${values.startDate} ${values.fromTime}:00`,
          newEnd: `${values.endDate} ${values.toTime}:00`,
          quantity: values.quantity,
          constructionId: values.construction_id,
          construction_id: values.construction_id,
          comment: values.comment,
          reservationId: reservationId, // only exists for editing existing reservations
          effectRange: effectRange, // only used to distinguish "all" and "future" edits, since "all" removed other recurrences
          repeatingFrequency: values.repeatingFrequency, // "none" | "daily" | "weekly" | "monthly" | "yearly" (If "none", ignore all other repeating fields)
          repeatingGap: values.repeatingGap, // number, space between each borrowing
          repeatingMonthWeek: values.repeatingMonthWeek, // If repeating monthly, which week of month (1-4, -1 for last)
          repeatingMonthDay: values.repeatingMonthDay, // IGNORED - If repeating monthly, which day of week (0-6) (7 is ok too) (not currently used, "from" date is used instead)
          repeatingMonth: values.repeatingMonth, // If repeating yearly, which month (1-12)
          repeatingDaysOfWeek: values.repeatingDaysOfWeek, // If repeating weekly, which days of week [0-6] (7 is ok too)
          repeatingEndDate: values.repeatingEndDate, // end date of repeating borrowing, this is used instead of number of occurrences
        };

        // this is a new reservation. It might be a one-time or a recurring one.
        if (!reservationId) {
          const res = await instrumentApi.borrowInstrument(apiPayload, values.instrumentItemId);
          setMessage(res.data.message);
        }

        // editing an existing, one-time reservation
        else if (effectRange === "") {
          console.log("Editing existing one-time reservation with payload:", apiPayload);
          const res = await instrumentApi.borrowInstrument(apiPayload, values.instrumentItemId);
          setMessage(res.data.message);
        }

        else if (effectRange === "all" || effectRange === "future") {
          const res = await instrumentApi.instrumentRecurring(apiPayload, values.instrumentItemId);
          setMessage(res.data.message);
        }

        else if (effectRange === "this") {
          const res = await instrumentApi.instrumentModify(apiPayload, values.instrumentItemId);
          setMessage(res.data.message);
        }

        else {
          console.error("Invalid effectRange value:", effectRange);
          setMessage("予期しないエラーが発生しました。");
        }

        setLoading(false);
        setShowModal(true);
        dispatch(setIdConstuctionEmployeeSearch(values.construction_id));
      } catch (error: any) {
        setLoading(false);
        showErrorFromApi(error);
      }
    } else {
      try {
        const res = await instrumentApi.updateBorrowItem(
          {
            from: moment(values.startDate).format("YYYY-MM-DD"),
            to: moment(values.endDate).format("YYYY-MM-DD"),
            quantity: values.quantity,
            construction_id: values.construction_id,
            comment: values.comment,
          },
          resId
        );
        setLoading(false);
        setShowModal(true);
        setMessage(res.data.message);
        dispatch(setIdConstuctionEmployeeSearch(values.construction_id));
      } catch (error: any) {
        setLoading(false);
        showErrorFromApi(error);
      }

    }
  };

  // events
  useEffect(() => {
    if (!productDetail) { return; }

    const out = calculateReservationsInMonth("2025-11", productDetail);

    console.log("Reservations for 2025-11 (+/- 7 days):", out);
  }, [productDetail]);

  useEffect(() => {
    if (parsed.itemId) {
      fetchHistoryProduct();
    } else {
      fetchProductApi();
    }
    return () => {
      // Do some cleanup
    };
  }, []);

  useEffect(() => {
    if (!instrument?.selectedDate && !queryStart) {
      console.log("Unused catch for - Redirecting to instruments list due to missing selected date");
//      history.push(appRouteEnums.PATH_INSTRUMENTS);
//      dispatch(
//        setInstrumentsCategory({
//          category: "",
//          subCategory: "",
//        })
//      );
    }
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSelectedDateInstrument(""));
    };
  }, []);
  return (
    <StyledInstrumentDetailView>
      {/* <AppTopBar /> */}
      <CircularLoader loading={loading} />
      <AppModal open={showModal} handleClose={handleCloseModal}>
        <AppAlert
          icon={<img src={hot_yellow_frame} alt="icon" />}
          text={message}
          handleClose={handleCloseModal}
        />
      </AppModal>
      {productDetail ? (
        <div className="InstrumentDetail">
          <div className="InstrumentDetail__top">
            <div className="InstrumentDetail__top-title">
              <p className="main">機器</p>
            </div>
          </div>
          <div className="InstrumentsDetail__content">
            <Grid container spacing={2} style={{ width: "100%" }}>
              <Grid item xs={12} md={12} style={{ maxWidth: "100%" }}>
                <InstrumentDetailInfoComponent
                  product={productDetail}
                  selectedDate={instrument?.selectedDate || queryStart || ""}
                  handleOnSubmit={createNewBorrow}
                />
              </Grid>
              <Grid item xs={12} md={12} style={{ maxWidth: "100%" }}>
                <InstrumentDetialHistoryComponent
                  historyList={productDetail?.history}
                />
              </Grid>

            </Grid>
          </div>
          {/* </div> */}
        </div>
      ) : (
        <div></div>
      )}
    </StyledInstrumentDetailView>
  );
};
